// {
//   "name": "iconic-image-behavior.js",
//   "author": "Arham Web Works"
//   "description": "Copying in any form is strictly prohibited. Any instance of copying will be subject to legal action and accountability under the law."
// }

var zoomInClass = 'animate--zoom-in';

function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var animationTriggerElements = Array.from(document.getElementsByClassName(zoomInClass));

  if (animationTriggerElements.length === 0) return;

  var scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    var observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });

    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener('scroll', function () {
      if (!elementIsVisible) return;

      element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
    }),
      { passive: true }
  });
}

function percentageSeen(element) {
  var viewportHeight = window.innerHeight;
  var scrollY = window.scrollY;
  var elementPositionY = element.getBoundingClientRect().top + scrollY;
  var elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  var distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}